import { FeatureKeys } from '@/config';
import { useAvailableFeatureChecker } from '@/hooks/useAvailableFeatureChecker';
import { useEffect, useState } from 'react';

const TRANSLATE_SEARCH_STORAGE_KEY = 'analyze-translate-search-enabled';

/**
 * ローカルストレージと同期する翻訳機能ON/OFF状態管理フック
 * 機能の可用性チェックも含めて完全に自立
 */
export const useTranslateSearchEnabled = () => {
  const [enabled, setEnabled] = useState(false);
  const { isAvailable, defaultConfiguration } = useAvailableFeatureChecker(
    FeatureKeys.searchTranslation
  );

  // 初期化: ローカルストレージ > デフォルト値
  useEffect(() => {
    if (!isAvailable) {
      setEnabled(false);
      return;
    }

    const defaultValue = defaultConfiguration?.activation ?? false;

    try {
      const stored = localStorage.getItem(TRANSLATE_SEARCH_STORAGE_KEY);
      setEnabled(stored !== null ? stored === 'true' : defaultValue);
    } catch (error) {
      console.warn('Failed to read from localStorage:', error);
      setEnabled(defaultValue);
    }
  }, [isAvailable, defaultConfiguration]);

  // 設定変更時にローカルストレージに保存
  const setEnabledWithStorage = (newEnabled: boolean) => {
    setEnabled(newEnabled);
    try {
      localStorage.setItem(TRANSLATE_SEARCH_STORAGE_KEY, String(newEnabled));
    } catch (error) {
      console.warn('Failed to write to localStorage:', error);
    }
  };

  return [enabled, setEnabledWithStorage] as const;
};
